import React from "react";
import PropTypes from "prop-types";
import PopoverMenu from '../UserSummary/PopoverMenu/PopoverMenu';
import Spinner from "apex-web/lib/components/common/Spinner/Spinner";
import { getBEMClasses } from "apex-web/lib/helpers/cssClassesHelper";

import "apex-web/lib/components/UserSummary/UserSummaryComponent.css";

class AccountsDropdown extends React.Component {
  static propTypes = {
    selectedAccount: PropTypes.shape({
      AccountName: PropTypes.string.isRequired,
    }),
    accounts: PropTypes.array.isRequired,
    tradingAccountId: PropTypes.string,
    retirementAccountId: PropTypes.string,
  };

  static contextTypes = {
    t: PropTypes.func.isRequired,
  };

  getMenuItems = () => {
    const { accounts, selectedAccount, tradingAccountId, retirementAccountId } =
      this.props;
    const menuItems = [
      ...accounts
        .filter((account) => account.AccountId !== selectedAccount.AccountId)
        .map((account) => {
          const accountName =
            account.AccountId === tradingAccountId
              ? this.context.t("Trading Account")
              : account.AccountId === retirementAccountId
                ? this.context.t("Retirement Account")
                : account.AccountName;
          return {
            label: this.context.t("Switch to {accountName}", {
              accountName,
            }),
            onClick: () =>
              this.props.selectAccount(account.AccountId, account.OMSID),
          };
        }),
    ];

    return menuItems;
  };

  updateTheme = () => {
    const { currentTheme } = this.props;
    const storedValues = JSON.parse(localStorage.getItem("apexTemplate")) || {};

    localStorage.setItem(
      "apexTemplate",
      JSON.stringify({
        ...storedValues,
        theme: currentTheme === "dark" ? "light" : "dark",
      }),
    );
  };

  render() {
    const {
      selectedAccount,
      customClass,
      retirementAccountId,
      tradingAccountId,
    } = this.props;
    const bemClasses = getBEMClasses(["user-summary", customClass]);

    const displayName =
      selectedAccount?.AccountId === tradingAccountId
        ? this.context.t("Trading Account")
        : selectedAccount?.AccountId === retirementAccountId
          ? this.context.t("Retirement Account")
          : selectedAccount?.AccountName;

    return (
      <div
        className={bemClasses("container")}
        data-account-switcher="true">
        {selectedAccount ? (
          <PopoverMenu
            customClass={bemClasses()}
            popoverProps={{
              trigger: (props) => (
                <button
                  type="button"
                  className={bemClasses("popover-menu-trigger")}
                  aria-label={this.context.t('Switch account')}
                  {...props}
                >
                  <span className={bemClasses("user-info-container")}>
                    <span className={bemClasses("username-in-display")}>
                      {displayName}
                    </span>
                    <span
                      className={bemClasses("popover-menu-trigger-triangle")}
                    />
                  </span>
                </button>
              ),
              customClass: "user-summary",
            }}
            items={this.getMenuItems()}
            updateTheme={this.updateTheme}
            currentTheme={this.props.currentTheme}
          />
        ) : (
          <Spinner isInline customClass={bemClasses} />
        )}
      </div>
    );
  }
}

export default AccountsDropdown;
